var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardEmployeeQueries(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dashboard-employee-queries",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 123.116,
    height: 82.159,
    viewBox: "0 0 123.116 82.159",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_198980",
    "data-name": "Rectangle 198980",
    width: 123.116,
    height: 82.158,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_232603",
    "data-name": "Group 232603",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_418782",
    "data-name": "Path 418782",
    d: "M793,15.871H745.806a2.373,2.373,0,0,0-2.372,2.373V52.027a2.373,2.373,0,0,0,2.372,2.373h49.567V18.244A2.373,2.373,0,0,0,793,15.871",
    transform: "translate(-710.057 -15.158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418783",
    "data-name": "Path 418783",
    d: "M793.273,52.4H743.706a2.474,2.474,0,0,1-2.471-2.472V16.144a2.474,2.474,0,0,1,2.471-2.472H790.9a2.474,2.474,0,0,1,2.471,2.472V52.3a.1.1,0,0,1-.1.1m-49.567-38.53a2.277,2.277,0,0,0-2.273,2.275V49.927a2.277,2.277,0,0,0,2.273,2.275h49.468V16.144a2.277,2.277,0,0,0-2.273-2.275Z",
    transform: "translate(-707.957 -13.058)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418784",
    "data-name": "Path 418784",
    d: "M824.437,81.589H778.655a1.473,1.473,0,0,1-1.471-1.472v-32.9a1.473,1.473,0,0,1,1.471-1.472h45.966a1.473,1.473,0,0,1,1.471,1.472v9.25a.1.1,0,1,1-.2,0v-9.25a1.276,1.276,0,0,0-1.274-1.275H778.655a1.276,1.276,0,0,0-1.274,1.275v32.9a1.276,1.276,0,0,0,1.274,1.275h45.781a1.46,1.46,0,0,0,1.458-1.459V70.186a.1.1,0,1,1,.2,0v9.746a1.658,1.658,0,0,1-1.656,1.657",
    transform: "translate(-742.292 -43.687)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418785",
    "data-name": "Path 418785",
    d: "M587.268,876.75h-54.5a3.526,3.526,0,0,1-3.526-3.526v-.287h61.555v.287a3.526,3.526,0,0,1-3.526,3.526",
    transform: "translate(-505.478 -833.746)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418786",
    "data-name": "Path 418786",
    d: "M585.167,874.747h-54.5a3.629,3.629,0,0,1-3.625-3.625v-.287a.1.1,0,0,1,.1-.1h61.556a.1.1,0,0,1,.1.1v.287a3.629,3.629,0,0,1-3.625,3.625m-57.931-3.813v.188a3.431,3.431,0,0,0,3.427,3.427h54.5a3.431,3.431,0,0,0,3.427-3.427v-.188Z",
    transform: "translate(-503.376 -831.645)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_198970",
    "data-name": "Rectangle 198970",
    width: 25.665,
    height: 2.151,
    transform: "translate(54.113 6.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418787",
    "data-name": "Path 418787",
    d: "M1228.88,151.73h-25.665a.1.1,0,0,1-.1-.1v-2.151a.1.1,0,0,1,.1-.1h25.665a.1.1,0,0,1,.1.1v2.151a.1.1,0,0,1-.1.1m-25.566-.2h25.467v-1.953h-25.467Z",
    transform: "translate(-1149.103 -142.675)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418788",
    "data-name": "Path 418788",
    d: "M1245.2,181.228h-9.484a.1.1,0,1,1,0-.2h9.484a.1.1,0,1,1,0,.2",
    transform: "translate(-1180.148 -172.904)",
    fill: "#5479f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_198971",
    "data-name": "Rectangle 198971",
    width: 8.405,
    height: 2.151,
    transform: "translate(40.708 6.805)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_198972",
    "data-name": "Rectangle 198972",
    width: 25.665,
    height: 2.151,
    transform: "translate(54.113 11.701)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418789",
    "data-name": "Path 418789",
    d: "M1228.88,260.768h-25.665a.1.1,0,0,1-.1-.1v-2.151a.1.1,0,0,1,.1-.1h25.665a.1.1,0,0,1,.1.1v2.151a.1.1,0,0,1-.1.1m-25.566-.2h25.467v-1.953h-25.467Z",
    transform: "translate(-1149.103 -246.818)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418790",
    "data-name": "Path 418790",
    d: "M1254.3,290.266h-18.579a.1.1,0,1,1,0-.2H1254.3a.1.1,0,1,1,0,.2",
    transform: "translate(-1180.148 -277.045)",
    fill: "#5479f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_198973",
    "data-name": "Rectangle 198973",
    width: 11.83,
    height: 2.151,
    transform: "translate(40.708 11.701)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_198974",
    "data-name": "Rectangle 198974",
    width: 25.665,
    height: 2.151,
    transform: "translate(54.113 16.596)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418791",
    "data-name": "Path 418791",
    d: "M1228.88,369.806h-25.665a.1.1,0,0,1-.1-.1v-2.151a.1.1,0,0,1,.1-.1h25.665a.1.1,0,0,1,.1.1v2.151a.1.1,0,0,1-.1.1m-25.566-.2h25.467v-1.953h-25.467Z",
    transform: "translate(-1149.103 -350.961)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418792",
    "data-name": "Path 418792",
    d: "M1238.468,399.3h-2.747a.1.1,0,1,1,0-.2h2.747a.1.1,0,0,1,0,.2",
    transform: "translate(-1180.148 -381.188)",
    fill: "#5479f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418793",
    "data-name": "Path 418793",
    d: "M1319.732,399.3h-2.747a.1.1,0,0,1,0-.2h2.747a.1.1,0,1,1,0,.2",
    transform: "translate(-1257.764 -381.188)",
    fill: "#5479f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418794",
    "data-name": "Path 418794",
    d: "M1405.683,399.3h-5.354a.1.1,0,1,1,0-.2h5.354a.1.1,0,1,1,0,.2",
    transform: "translate(-1337.366 -381.188)",
    fill: "#5479f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_198975",
    "data-name": "Rectangle 198975",
    width: 11.804,
    height: 2.151,
    transform: "translate(40.708 16.596)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_198976",
    "data-name": "Rectangle 198976",
    width: 11.804,
    height: 2.151,
    transform: "translate(40.708 21.491)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_198977",
    "data-name": "Rectangle 198977",
    width: 11.804,
    height: 2.151,
    transform: "translate(40.708 26.38)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418795",
    "data-name": "Path 418795",
    d: "M1314.817,468.48h-2.572a.1.1,0,0,1-.1-.1v-2.568a.1.1,0,0,1,.1-.1h2.062a.1.1,0,1,1,0,.2h-1.963v2.37h2.375v-1.524a.1.1,0,0,1,.2,0v1.623a.1.1,0,0,1-.1.1",
    transform: "translate(-1253.237 -444.807)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418796",
    "data-name": "Path 418796",
    d: "M1322.361,455.754a.1.1,0,0,1-.08-.041l-1.008-1.408a.1.1,0,0,1,.161-.115l.928,1.3,1.676-2.331a.1.1,0,1,1,.16.115l-1.756,2.443a.1.1,0,0,1-.08.041",
    transform: "translate(-1261.936 -432.771)",
    fill: "#5479f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418797",
    "data-name": "Path 418797",
    d: "M1208.21,468.822h-2.558a.1.1,0,0,1-.1-.1v-2.558a.1.1,0,0,1,.1-.1h2.558a.1.1,0,0,1,.1.1v2.558a.1.1,0,0,1-.1.1m-2.46-.2h2.361v-2.361h-2.361Z",
    transform: "translate(-1151.429 -445.142)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418798",
    "data-name": "Path 418798",
    d: "M1207.906,576.185h-2.572a.1.1,0,0,1-.1-.1v-2.568a.1.1,0,0,1,.1-.1h2.047a.1.1,0,0,1,0,.2h-1.948v2.37h2.375v-1.394a.1.1,0,1,1,.2,0v1.493a.1.1,0,0,1-.1.1",
    transform: "translate(-1151.126 -547.676)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418799",
    "data-name": "Path 418799",
    d: "M1215.45,563.458a.1.1,0,0,1-.08-.041l-1.008-1.409a.1.1,0,1,1,.161-.115l.928,1.3,1.676-2.331a.1.1,0,1,1,.16.115l-1.757,2.443a.1.1,0,0,1-.08.041",
    transform: "translate(-1159.825 -535.639)",
    fill: "#5479f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_198978",
    "data-name": "Rectangle 198978",
    width: 25.665,
    height: 2.151,
    transform: "translate(54.113 31.292)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418800",
    "data-name": "Path 418800",
    d: "M1228.88,697.149h-25.665a.1.1,0,0,1-.1-.1V694.9a.1.1,0,0,1,.1-.1h25.665a.1.1,0,0,1,.1.1v2.151a.1.1,0,0,1-.1.1m-25.566-.2h25.467V695h-25.467Z",
    transform: "translate(-1149.103 -663.608)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418801",
    "data-name": "Path 418801",
    d: "M1245.2,726.646h-9.484a.1.1,0,1,1,0-.2h9.484a.1.1,0,1,1,0,.2",
    transform: "translate(-1180.148 -693.835)",
    fill: "#5479f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_198979",
    "data-name": "Rectangle 198979",
    width: 8.405,
    height: 2.151,
    transform: "translate(40.708 31.292)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418802",
    "data-name": "Path 418802",
    d: "M1315.121,576.526h-2.558a.1.1,0,0,1-.1-.1v-2.558a.1.1,0,0,1,.1-.1h2.558a.1.1,0,0,1,.1.1v2.558a.1.1,0,0,1-.1.1m-2.46-.2h2.361v-2.361h-2.361Z",
    transform: "translate(-1253.54 -548.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418803",
    "data-name": "Path 418803",
    d: "M99.542,1143.2l-2.622-10.55a11.492,11.492,0,0,1,22.248-5.749l4.094,14.551-21.933-.019Z",
    transform: "translate(-92.269 -1068.295)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418804",
    "data-name": "Path 418804",
    d: "M97.463,1141.195a.1.1,0,0,1-.1-.075l-2.622-10.551a11.59,11.59,0,0,1,11.279-14.257,11.653,11.653,0,0,1,1.77.135.1.1,0,1,1-.03.2,11.447,11.447,0,0,0-1.74-.133,11.393,11.393,0,0,0-11.087,14.014l2.621,10.549a.1.1,0,0,1-.072.12l-.024,0",
    transform: "translate(-90.191 -1066.195)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418805",
    "data-name": "Path 418805",
    d: "M130.8,1175.8a.1.1,0,0,1-.1-.075l-2.305-9.3a11.587,11.587,0,0,1,5.226-12.558.1.1,0,0,1,.1.168,11.389,11.389,0,0,0-5.137,12.343l2.3,9.3a.1.1,0,0,1-.072.12l-.024,0",
    transform: "translate(-122.338 -1102.051)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418806",
    "data-name": "Path 418806",
    d: "M.1,1635.9a.1.1,0,0,1-.07-.169l8.952-8.873a.1.1,0,0,1,.07-.029h4.168a.1.1,0,1,1,0,.2H9.092l-8.923,8.844a.1.1,0,0,1-.07.029",
    transform: "translate(-0.001 -1553.789)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418807",
    "data-name": "Path 418807",
    d: "M1115.867,1134.984a1.212,1.212,0,0,0-.829-.774,2.858,2.858,0,0,0-1.089-.027l-6.932.72a10.737,10.737,0,0,0,5.05,1.362c.721.029,4.354.435,3.8-1.282",
    transform: "translate(-1057.317 -1083.227)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418808",
    "data-name": "Path 418808",
    d: "M1111.4,1134.331c-.455,0-.878-.027-1.17-.046-.11-.007-.2-.013-.267-.016a10.848,10.848,0,0,1-5.1-1.375.1.1,0,0,1,.04-.183l6.932-.721a2.972,2.972,0,0,1,1.127.03,1.3,1.3,0,0,1,.9.838.882.882,0,0,1-.1.856c-.395.507-1.442.617-2.356.617m-6.164-1.456a10.825,10.825,0,0,0,4.735,1.2c.067,0,.16.009.272.016.774.05,2.83.182,3.357-.495a.688.688,0,0,0,.072-.674,1.105,1.105,0,0,0-.762-.709,2.781,2.781,0,0,0-1.052-.024Z",
    transform: "translate(-1055.217 -1081.131)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418809",
    "data-name": "Path 418809",
    d: "M771.16,1074.677c.814-2.4,3.634-3.561,4.615-3.927s1.155,1.234-.388,2.225-1.023,1.385-1.023,1.385,9.172-.168,9.856.864c.334.5.629,1.7-3.072,1.823-1.048.034-2.709.023-3.259,1.746-.105.329-2.869,16.005-8.634,16.007-6.518,0-9.936-10.6-9.936-10.6l6.283-5.358s2.666,5.206,2.638,5.136c.543-1.336,2.715-8.695,2.921-9.3",
    transform: "translate(-725.228 -1022.627)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418810",
    "data-name": "Path 418810",
    d: "M767.153,1092.79c-2.7,0-5.291-1.848-7.494-5.344a26.743,26.743,0,0,1-2.534-5.322.1.1,0,0,1,.03-.105l6.283-5.358a.1.1,0,0,1,.152.03c.773,1.509,2.155,4.205,2.536,4.942.454-1.227,1.58-4.95,2.27-7.229.3-.983.513-1.693.572-1.869.718-2.119,2.938-3.339,4.674-3.988a.591.591,0,0,1,.8.249c.263.525-.085,1.5-1.1,2.151-.909.584-1.055.932-1.062,1.087a.2.2,0,0,0,.028.116c1.134-.02,9.211-.123,9.9.909a.961.961,0,0,1,.112.973c-.312.605-1.41.943-3.263,1l-.113,0c-1.074.033-2.545.078-3.055,1.674-.006.021-.032.147-.065.306a54.874,54.874,0,0,1-2.461,8.708c-1.823,4.685-3.909,7.061-6.2,7.062Zm-9.819-10.664a26.671,26.671,0,0,0,2.495,5.218c1.509,2.394,4.005,5.248,7.325,5.248h0c4.743,0,7.5-10.919,8.469-15.612.045-.22.062-.3.07-.326.553-1.729,2.168-1.778,3.238-1.811l.113,0c2.212-.073,2.9-.528,3.094-.9a.773.773,0,0,0-.1-.773c-.536-.81-7.236-.866-9.772-.82a.1.1,0,0,1-.062-.02.36.36,0,0,1-.123-.3c.014-.344.4-.763,1.152-1.245.98-.629,1.23-1.505,1.035-1.9-.1-.2-.3-.251-.559-.153-1.7.635-3.863,1.821-4.556,3.867-.058.172-.273.881-.57,1.863-.733,2.421-1.958,6.471-2.351,7.442a.1.1,0,0,1-.052.059c-.065.03-.1-.005-.132-.053v0c-.009-.015-.018-.031-.026-.047l-.085-.163-.3-.582-.906-1.766-1.26-2.458Z",
    transform: "translate(-723.129 -1020.518)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418811",
    "data-name": "Path 418811",
    d: "M930.207,1368.522a.1.1,0,0,1-.028,0,.1.1,0,0,1-.067-.123l1.154-3.9a.1.1,0,0,1,.189.056l-1.154,3.9a.1.1,0,0,1-.095.071",
    transform: "translate(-888.351 -1303.167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418812",
    "data-name": "Path 418812",
    d: "M282.3,1080.187l4.8-3.769s-.854-1.8-2.979-5.9a7.783,7.783,0,0,0-4.93-3.948,35.974,35.974,0,0,0-15.421-.811,5.141,5.141,0,0,0-3.238,2.083c-2.04,2.892-3.106,8.794-4.4,13.083l8.344.153-1.987,6.945,16.112-.093Z",
    transform: "translate(-244.629 -1017.424)",
    fill: "#76999b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418813",
    "data-name": "Path 418813",
    d: "M267.783,1412.035h-26.2a5.233,5.233,0,0,1-5.1-6.4l.754-3.291s5.8-1.373,9.584.153l-.79,3.174h12.283a10.5,10.5,0,0,1,6.464,2.171,8.532,8.532,0,0,1,3,4.194",
    transform: "translate(-225.739 -1338.842)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418814",
    "data-name": "Path 418814",
    d: "M265.693,1422.1H239.5a5.332,5.332,0,0,1-5.2-6.522l.754-3.291a.1.1,0,1,1,.192.044l-.754,3.291a5.134,5.134,0,0,0,5,6.28h26.062a8.418,8.418,0,0,0-2.929-4.018,10.025,10.025,0,0,0-3.017-1.608.1.1,0,1,1,.062-.187,10.225,10.225,0,0,1,3.077,1.64,8.581,8.581,0,0,1,3.037,4.243.1.1,0,0,1-.094.128",
    transform: "translate(-223.65 -1348.808)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418815",
    "data-name": "Path 418815",
    d: "M793.419,1544.528a.1.1,0,0,1-.091-.062,4.824,4.824,0,0,0-3.1-2.767.1.1,0,1,1,.054-.19,5.024,5.024,0,0,1,3.225,2.883.1.1,0,0,1-.091.136",
    transform: "translate(-754.686 -1472.299)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418816",
    "data-name": "Path 418816",
    d: "M741.9,1554.258a.1.1,0,0,1-.09-.058,4.466,4.466,0,0,0-2.616-2.378.1.1,0,0,1,.063-.187,4.667,4.667,0,0,1,2.734,2.484.1.1,0,0,1-.09.139",
    transform: "translate(-705.943 -1481.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418817",
    "data-name": "Path 418817",
    d: "M477.9,1268.205a.094.094,0,0,1-.029,0,.1.1,0,0,1-.066-.123l1.716-5.612a2.555,2.555,0,0,1,.392-.868.923.923,0,0,1,.9-.372.1.1,0,1,1-.045.192.744.744,0,0,0-.7.3,2.367,2.367,0,0,0-.358.8l-1.716,5.612a.1.1,0,0,1-.094.07",
    transform: "translate(-456.346 -1204.585)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418818",
    "data-name": "Path 418818",
    d: "M556.365,1077.21a2.234,2.234,0,0,1-1.208-.383,4.55,4.55,0,0,1-1.179-1.229c-2.092-2.965-2.766-6.717-3.36-10.028a.1.1,0,0,1,.194-.035c.59,3.291,1.259,7.021,3.327,9.949a4.364,4.364,0,0,0,1.125,1.178,1.866,1.866,0,0,0,1.515.295c.95-.272,1.36-1.418,1.537-2.331a15.191,15.191,0,0,0-.75-8.3.1.1,0,1,1,.184-.072,15.39,15.39,0,0,1,.76,8.409c-.269,1.387-.848,2.246-1.677,2.483a1.7,1.7,0,0,1-.469.064",
    transform: "translate(-525.897 -1017.619)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418819",
    "data-name": "Path 418819",
    d: "M765.4,1306.234a2.348,2.348,0,0,1-.532-.06.1.1,0,1,1,.045-.192,2.639,2.639,0,0,0,2.507-.9,3.689,3.689,0,0,0,.8-2.639,6.175,6.175,0,0,0-.9-2.688.1.1,0,1,1,.171-.1,6.372,6.372,0,0,1,.927,2.775,3.888,3.888,0,0,1-.852,2.781,2.929,2.929,0,0,1-2.169,1.02",
    transform: "translate(-730.454 -1241.263)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418820",
    "data-name": "Path 418820",
    d: "M519.907,780.356q-.365-2.23-.885-4.434-.131-.556-.272-1.111c-.066-.26-.33-.8-.259-1.053.06-.218.372-.424.463-.669a1.557,1.557,0,0,0,.054-.887,2.455,2.455,0,0,0-1.025-1.385,6.816,6.816,0,0,0-4.256-.872,6.916,6.916,0,0,0-4.321,1.341A5.952,5.952,0,0,0,507.739,775a29.765,29.765,0,0,0-.043,6.47.935.935,0,0,0,.929.867,62.68,62.68,0,0,0,10.334-.567,1.384,1.384,0,0,0,.766-.294,1.244,1.244,0,0,0,.183-1.117",
    transform: "translate(-484.754 -735.361)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418821",
    "data-name": "Path 418821",
    d: "M572.854,947.806l-.471,4.239-4.49-4.679a2,2,0,0,0,1.34-1.369l1.222-4.32,3.4,1.706Z",
    transform: "translate(-542.396 -899.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418822",
    "data-name": "Path 418822",
    d: "M570.752,945.8l-.022,0a.1.1,0,0,1-.075-.118l.981-4.348-3.223-1.618-1.189,4.205a2.091,2.091,0,0,1-1.406,1.436.1.1,0,0,1-.058-.189,1.894,1.894,0,0,0,1.274-1.3l1.222-4.32a.1.1,0,0,1,.139-.061l3.4,1.706a.1.1,0,0,1,.052.11l-1,4.423a.1.1,0,0,1-.1.077",
    transform: "translate(-540.294 -897.299)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418823",
    "data-name": "Path 418823",
    d: "M573.606,840.765s-.823-1.391-1.725-1.11c-1.374.428-1.286,2.884.979,2.766,0,0,2.68,3.423,5.25,2.473s.685-6.739.187-7.732c0,0-3.415-.455-3.67,1.6-.148,1.2.14,2-1.021,2",
    transform: "translate(-545.342 -799.536)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418824",
    "data-name": "Path 418824",
    d: "M575.054,843.026c-2.131,0-4.063-2.29-4.346-2.64a1.667,1.667,0,0,1-1.913-1.3,1.452,1.452,0,0,1,.95-1.664c.874-.273,1.647.849,1.809,1.105.758-.018.777-.411.813-1.178.01-.219.022-.468.055-.734a1.63,1.63,0,0,1,.641-1.128,4.991,4.991,0,0,1,3.14-.562.1.1,0,0,1,.075.054c.4.8,1.692,4.659.884,6.708a1.91,1.91,0,0,1-1.124,1.161,2.82,2.82,0,0,1-.984.175m-4.3-2.839a.1.1,0,0,1,.078.038c.026.034,2.666,3.355,5.138,2.441a1.721,1.721,0,0,0,1.009-1.048c.73-1.85-.373-5.5-.853-6.5a4.756,4.756,0,0,0-2.942.528,1.44,1.44,0,0,0-.565,1c-.032.259-.044.5-.054.719-.038.793-.065,1.367-1.065,1.367a.1.1,0,0,1-.085-.048c-.008-.013-.794-1.32-1.611-1.066a1.259,1.259,0,0,0-.814,1.441c.1.586.622,1.192,1.759,1.132h.005",
    transform: "translate(-543.235 -797.401)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418825",
    "data-name": "Path 418825",
    d: "M589.658,925.752a.1.1,0,0,1-.068-.027,1.365,1.365,0,0,0-1.188-.343.1.1,0,0,1-.039-.194,1.565,1.565,0,0,1,1.363.394.1.1,0,0,1-.068.17",
    transform: "translate(-561.873 -883.625)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418826",
    "data-name": "Path 418826",
    d: "M682.943,887.257a.958.958,0,1,1-1.172-.889,1.049,1.049,0,0,1,1.172.889",
    transform: "translate(-650.495 -846.555)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418827",
    "data-name": "Path 418827",
    d: "M680,886.59a1.2,1.2,0,0,1-1.091-.985,1.055,1.055,0,1,1,2.028-.469h0a1.148,1.148,0,0,1-.737,1.432.892.892,0,0,1-.2.023m-.152-2.243a.7.7,0,0,0-.157.018,1.052,1.052,0,1,0,1.054.815,1,1,0,0,0-.9-.833",
    transform: "translate(-648.398 -844.456)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418828",
    "data-name": "Path 418828",
    d: "M738.719,874.354a.958.958,0,1,1-1.172-.889,1.049,1.049,0,0,1,1.172.889",
    transform: "translate(-703.767 -834.232)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418829",
    "data-name": "Path 418829",
    d: "M735.781,873.68a1.2,1.2,0,0,1-1.091-.985,1.148,1.148,0,0,1,.737-1.432.961.961,0,0,1,.805.19,1.393,1.393,0,0,1,.389,1.68.962.962,0,0,1-.64.524.885.885,0,0,1-.2.023m-.151-2.243a.694.694,0,0,0-.158.018,1.052,1.052,0,0,0,.465,2.009.768.768,0,0,0,.508-.421,1.146,1.146,0,0,0,.081-.774h0a1.146,1.146,0,0,0-.412-.66.8.8,0,0,0-.484-.173",
    transform: "translate(-701.67 -832.125)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418830",
    "data-name": "Path 418830",
    d: "M720.637,899.889a.1.1,0,0,1-.076-.161.629.629,0,0,1,.795-.177.1.1,0,1,1-.1.17.446.446,0,0,0-.542.133.1.1,0,0,1-.076.035",
    transform: "translate(-688.19 -859.089)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418831",
    "data-name": "Path 418831",
    d: "M629.249,910.936h-.006l-2.374-.146a.1.1,0,0,1,.012-.2l2.374.146a.1.1,0,0,1-.006.2",
    transform: "translate(-598.637 -869.711)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418832",
    "data-name": "Path 418832",
    d: "M576.236,772.38s-2.729.756-1.908,5.1l-1.216.352s-1.348-5.618,3.124-5.448",
    transform: "translate(-547.199 -737.701)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418833",
    "data-name": "Path 418833",
    d: "M570.932,775.827a.1.1,0,0,1-.1-.076c-.029-.121-.7-2.985.6-4.571a3.044,3.044,0,0,1,2.621-1,.1.1,0,0,1,.023.194c-.108.03-2.631.79-1.838,4.983a.1.1,0,0,1-.069.113l-1.216.352a.1.1,0,0,1-.027,0m2.667-5.444a2.669,2.669,0,0,0-2.007.923c-1.105,1.348-.692,3.775-.586,4.3l1.029-.3c-.581-3.228.818-4.491,1.564-4.924",
    transform: "translate(-545.019 -735.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418834",
    "data-name": "Path 418834",
    d: "M601.233,961.083a1.262,1.262,0,0,1-.874-.351l-1.516-1.461a.1.1,0,1,1,.137-.142l1.516,1.461a1.063,1.063,0,0,0,1.023.257l2.376-.67a.1.1,0,0,1,.054.19l-2.376.67a1.248,1.248,0,0,1-.339.047",
    transform: "translate(-571.929 -916.042)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418835",
    "data-name": "Path 418835",
    d: "M693.437,973.631c.054.276-.323.583-.842.684s-.984-.041-1.037-.317.323-.583.842-.684.984.041,1.037.317",
    transform: "translate(-660.504 -929.586)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418836",
    "data-name": "Path 418836",
    d: "M690.165,972.346a1.354,1.354,0,0,1-.392-.054.532.532,0,0,1-.412-.376c-.065-.335.339-.686.92-.8a1.57,1.57,0,0,1,.741.019.532.532,0,0,1,.412.376h0c.065.335-.339.686-.92.8a1.823,1.823,0,0,1-.349.035m.466-1.067a1.633,1.633,0,0,0-.312.031c-.5.1-.8.377-.764.568.018.095.119.177.276.225a1.369,1.369,0,0,0,.645.014c.5-.1.8-.377.764-.568-.019-.095-.119-.177-.276-.225a1.151,1.151,0,0,0-.334-.045",
    transform: "translate(-658.405 -927.485)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418837",
    "data-name": "Path 418837",
    d: "M552.715,881.3a2.364,2.364,0,1,1-1.923-2.737,2.365,2.365,0,0,1,1.923,2.737",
    transform: "translate(-523.419 -839.09)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418838",
    "data-name": "Path 418838",
    d: "M548.285,881.26a2.494,2.494,0,0,1-.427-.037,2.449,2.449,0,1,1,.427.037m-.008-4.734a2.268,2.268,0,1,0,.393.034,2.287,2.287,0,0,0-.393-.034",
    transform: "translate(-521.313 -836.985)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418839",
    "data-name": "Path 418839",
    d: "M566.818,895.989a1.669,1.669,0,1,1-1.357-1.932,1.67,1.67,0,0,1,1.357,1.932",
    transform: "translate(-538.206 -853.894)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418840",
    "data-name": "Path 418840",
    d: "M563.071,895.37a1.774,1.774,0,0,1-.3-.026,1.767,1.767,0,1,1,.3.026m0-3.341a1.572,1.572,0,1,0,.272.024,1.582,1.582,0,0,0-.272-.024m1.647,1.858h0Z",
    transform: "translate(-536.103 -851.792)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418841",
    "data-name": "Path 418841",
    d: "M1122.1,1576.842h-31.789a.8.8,0,0,1-.794-.795v-.187a1.563,1.563,0,0,1,1.563-1.563h33.312l-.268.994a2.1,2.1,0,0,1-2.024,1.551",
    transform: "translate(-1040.599 -1503.618)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418842",
    "data-name": "Path 418842",
    d: "M1390.273,1231.474h-19.658a1.292,1.292,0,0,1-1.254-1.6l3.715-14.989a1.292,1.292,0,0,1,1.254-.981h19.658a1.292,1.292,0,0,1,1.254,1.6l-3.715,14.989a1.292,1.292,0,0,1-1.254.981",
    transform: "translate(-1307.846 -1159.402)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418843",
    "data-name": "Path 418843",
    d: "M1389.224,1230.474h-19.658a1.341,1.341,0,0,1-1.3-1.664l3.715-14.989a1.339,1.339,0,0,1,1.3-1.019h19.658a1.342,1.342,0,0,1,1.3,1.664l-3.715,14.989a1.339,1.339,0,0,1-1.3,1.019m-15.943-17.573a1.241,1.241,0,0,0-1.206.944l-3.715,14.989a1.243,1.243,0,0,0,1.206,1.542h19.658a1.24,1.24,0,0,0,1.206-.944l3.715-14.989a1.243,1.243,0,0,0-1.206-1.542Z",
    transform: "translate(-1306.797 -1158.354)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418844",
    "data-name": "Path 418844",
    d: "M1674.186,1328.916a.649.649,0,1,1-.649-.649.649.649,0,0,1,.649.649",
    transform: "translate(-1597.783 -1268.634)",
    fill: "#5479f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418845",
    "data-name": "Path 418845",
    d: "M733.969,1598.209l9.161.135a.678.678,0,0,0,.529-1.114,6.3,6.3,0,0,0-2.851-1.871c-1.93-.643-5.219.965-7.055,2.012a.449.449,0,0,0,.215.839",
    transform: "translate(-700.594 -1523.594)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418846",
    "data-name": "Path 418846",
    d: "M742.08,1597.361h-.011l-9.161-.135a.5.5,0,0,1-.239-.931c1.811-1.032,5.14-2.667,7.095-2.016a6.378,6.378,0,0,1,2.873,1.886.727.727,0,0,1-.556,1.2m-3.342-3.133c-1.923,0-4.506,1.289-6.021,2.153a.4.4,0,0,0,.191.746l9.161.135h.01a.623.623,0,0,0,.57-.363.617.617,0,0,0-.089-.67,6.28,6.28,0,0,0-2.829-1.856,3.145,3.145,0,0,0-.994-.145",
    transform: "translate(-699.534 -1522.562)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418847",
    "data-name": "Path 418847",
    d: "M965.506,1637.8h-4.152a3.593,3.593,0,0,1-3.589-3.588,1.889,1.889,0,1,0-3.778,0,2.177,2.177,0,0,1-2.175,2.175h-.619a2.177,2.177,0,0,1-2.175-2.175v-2.562a1.626,1.626,0,0,0-1.624-1.624h-2.051a.1.1,0,0,1,0-.2h2.051a1.824,1.824,0,0,1,1.822,1.822v2.562a1.98,1.98,0,0,0,1.977,1.977h.619a1.98,1.98,0,0,0,1.977-1.977,2.087,2.087,0,1,1,4.173,0,3.4,3.4,0,0,0,3.391,3.391h4.152a3.4,3.4,0,0,0,3.391-3.391v-5.345a.1.1,0,1,1,.2,0v5.345a3.593,3.593,0,0,1-3.589,3.588",
    transform: "translate(-902.807 -1555.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418848",
    "data-name": "Path 418848",
    d: "M1974.2,33.746h-2.8a.1.1,0,1,1,0-.2h2.7V.2H1938.4V10.442a.1.1,0,1,1-.2,0V.1a.1.1,0,0,1,.1-.1h35.9a.1.1,0,0,1,.1.1V33.647a.1.1,0,0,1-.1.1",
    transform: "translate(-1851.186)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418849",
    "data-name": "Path 418849",
    d: "M2143.382,38.631s-3.03.877-2.795-2.281c.212-2.84,1.207-.665,1.609-.792.434-.136.076-1.01.635-1.081s.974.732,1.524.592,1.648-.984,2.71-.372a2.018,2.018,0,0,1,.931,1.56s1.1.093,1.355,1.769-2.032,4.8-2.032,4.8Z",
    transform: "translate(-2044.473 -32.925)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418850",
    "data-name": "Path 418850",
    d: "M2210.69,187.5l1.616,4.726a.892.892,0,0,0,.673.587l.719.14s-1.871,4.062-5.023,3.382-2.459-3.382-2.459-3.382l.667-.054a.646.646,0,0,0,.573-.8l-.75-2.9s3.055-2.463,3.983-1.69",
    transform: "translate(-2107.106 -178.937)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418851",
    "data-name": "Path 418851",
    d: "M2207.245,194.5a3.412,3.412,0,0,1-.722-.078,3.249,3.249,0,0,1-2.2-1.374,2.969,2.969,0,0,1-.331-2.129.1.1,0,0,1,.088-.074l.667-.054a.547.547,0,0,0,.485-.682l-.75-2.9a.1.1,0,0,1,.033-.1c.127-.1,3.13-2.5,4.109-1.689a.1.1,0,0,1,.03.044l1.616,4.726a.8.8,0,0,0,.6.522l.719.14a.1.1,0,0,1,.069.052.1.1,0,0,1,0,.086c-.017.038-1.653,3.515-4.412,3.515m-3.079-3.464a2.8,2.8,0,0,0,.323,1.91,3.062,3.062,0,0,0,2.075,1.283c2.744.592,4.524-2.567,4.856-3.213l-.592-.115a.993.993,0,0,1-.748-.652l-1.606-4.7c-.72-.534-2.926.982-3.788,1.667l.734,2.843a.744.744,0,0,1-.661.928Z",
    transform: "translate(-2104.975 -176.932)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418852",
    "data-name": "Path 418852",
    d: "M2180.153,109.219a2.627,2.627,0,0,1-2.834,1.474c-2.051-.334-2.1-2.943-1.919-5.716a2.421,2.421,0,0,0,1.185.23,8,8,0,0,0,2.826-.588,2.081,2.081,0,0,0-.044,2.091,1.21,1.21,0,0,0,1.016.387.639.639,0,0,1,1.033-.364,1.488,1.488,0,0,1-1.263,2.487",
    transform: "translate(-2077.669 -99.923)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418853",
    "data-name": "Path 418853",
    d: "M2175.7,108.627a3.14,3.14,0,0,1-.506-.042c-2.179-.355-2.176-3.19-2-5.819a.1.1,0,0,1,.142-.082,2.351,2.351,0,0,0,1.138.22,9.1,9.1,0,0,0,2.743-.536.094.094,0,0,1,.127-.048.1.1,0,0,1,.05.134c-.264.621-.489,1.47-.059,1.989a1.089,1.089,0,0,0,.872.349.853.853,0,0,1,.45-.484.78.78,0,0,1,.705.138,1.406,1.406,0,0,1,.351,1.611,1.529,1.529,0,0,1-1.608,1.062,2.751,2.751,0,0,1-2.4,1.511m-2.32-5.707c-.158,2.5-.132,5.148,1.846,5.47a2.543,2.543,0,0,0,2.727-1.416.1.1,0,0,1,.1-.059,1.333,1.333,0,0,0,1.472-.924,1.227,1.227,0,0,0-.271-1.381.6.6,0,0,0-.53-.118.727.727,0,0,0-.355.428.1.1,0,0,1-.1.07,1.317,1.317,0,0,1-1.094-.426,1.993,1.993,0,0,1-.07-1.93,11.254,11.254,0,0,1-2.63.467,2.6,2.6,0,0,1-1.1-.18",
    transform: "translate(-2075.564 -97.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418854",
    "data-name": "Path 418854",
    d: "M2291.987,167.211a.1.1,0,0,1-.094-.131,1.583,1.583,0,0,1,.193-.42.6.6,0,0,1,.431-.264.1.1,0,0,1,.105.092.1.1,0,0,1-.092.105.405.405,0,0,0-.284.182,1.4,1.4,0,0,0-.167.369.1.1,0,0,1-.093.067",
    transform: "translate(-2188.993 -158.926)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418855",
    "data-name": "Path 418855",
    d: "M1833.439,308.117a5.5,5.5,0,0,1,3.918-2.205c.889-.082,2-.169,3.247-.233a2.855,2.855,0,0,0,.288.645,3.486,3.486,0,0,0,1.553,1.333,3.834,3.834,0,0,0,2.021.329,2.876,2.876,0,0,0,1.779-.87,3.479,3.479,0,0,0,.951-1.439,29.349,29.349,0,0,1,3.075.323,6.987,6.987,0,0,1,4.864,3.263c1.959,3.2,5.351,8.879,5.532,13.451.292,7.369-11.823,2.886-11.823,2.886l-13.42-.075-.475-2.655a6.883,6.883,0,0,1-4.654-.2c-2.736-1.38-7.375-8.249-7.375-8.249l5.184-5.773,3.255,2.859a34.42,34.42,0,0,1,2.08-3.392",
    transform: "translate(-1741.08 -291.954)",
    fill: "#4256a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418856",
    "data-name": "Path 418856",
    d: "M2350.139,606.694h0l-9.045-.172a.1.1,0,0,1-.1-.1.1.1,0,0,1,.1-.1l9.045.172a.1.1,0,0,1,0,.2",
    transform: "translate(-2235.896 -579.104)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418857",
    "data-name": "Path 418857",
    d: "M2435.383,522.85a.1.1,0,0,1-.094-.07,15.061,15.061,0,0,0-1.336-3.12c-.152-.268-.292-.39-.442-.385a.1.1,0,0,1-.007-.2c.3-.007.5.272.62.485a15.264,15.264,0,0,1,1.354,3.16.1.1,0,0,1-.066.123.1.1,0,0,1-.028,0",
    transform: "translate(-2324.16 -495.773)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418858",
    "data-name": "Path 418858",
    d: "M2083.86,437.761a.1.1,0,0,1-.1-.09,45.258,45.258,0,0,1,.373-11,.1.1,0,1,1,.193.041,45.063,45.063,0,0,0-.37,10.942.1.1,0,0,1-.089.107h-.009",
    transform: "translate(-1990.04 -407.439)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418859",
    "data-name": "Path 418859",
    d: "M2010.76,436.2a.1.1,0,0,1-.079-.039l-1.981-2.641a.1.1,0,1,1,.158-.118l1.981,2.641a.1.1,0,0,1-.079.158",
    transform: "translate(-1918.499 -413.907)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418860",
    "data-name": "Path 418860",
    d: "M2179.426,614.207c-2.295.058-10.381,0-10.381,0s-.433-7.148,7.408-6.285a11.283,11.283,0,0,1,2.972,6.285",
    transform: "translate(-2071.661 -580.56)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418861",
    "data-name": "Path 418861",
    d: "M2257.572,695.831a.1.1,0,0,1-.1-.084,2.061,2.061,0,0,1,.286-1.32,3.655,3.655,0,0,1,.9-1.026,1.215,1.215,0,0,1,.281-.185.1.1,0,1,1,.079.181,1.062,1.062,0,0,0-.235.157,3.483,3.483,0,0,0-.855.97,1.871,1.871,0,0,0-.262,1.195.1.1,0,0,1-.083.112h-.014",
    transform: "translate(-2156.107 -662.086)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418862",
    "data-name": "Path 418862",
    d: "M2218.092,685.061h-.014a.1.1,0,0,1-.084-.112,6.892,6.892,0,0,1,.381-1.585,3.121,3.121,0,0,1,.959-1.334.1.1,0,1,1,.12.157,2.926,2.926,0,0,0-.9,1.25,6.715,6.715,0,0,0-.369,1.539.1.1,0,0,1-.1.085",
    transform: "translate(-2118.415 -651.39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418863",
    "data-name": "Path 418863",
    d: "M2185.454,674.529a.1.1,0,0,1-.1-.087,4.189,4.189,0,0,1,1.146-3.433.1.1,0,0,1,.135.144,4.065,4.065,0,0,0-1.085,3.265.1.1,0,0,1-.086.11h-.012",
    transform: "translate(-2087.214 -640.858)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418864",
    "data-name": "Path 418864",
    d: "M1618.495,301.8s-4.791-3.691-7.209-3.83c-3.141-.181-7.594,3.309-7.594,3.309a.743.743,0,0,0-.146,1.1,1.056,1.056,0,0,0,.747.184l2.7-1.082c-.018,1.9,1.463,1.6,1.463,1.6-.344.982,1.1,1.2,1.1,1.2.723,1.2,2.114.432,2.114.432l2.021,2.076c3.594-1.393,3.905-2.884,4.8-4.981",
    transform: "translate(-1531.38 -284.584)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418865",
    "data-name": "Path 418865",
    d: "M1611.591,304.776a.1.1,0,0,1-.071-.03l-1.971-2.025a1.642,1.642,0,0,1-2.153-.463,1.71,1.71,0,0,1-1.086-.61.761.761,0,0,1-.09-.561,1.326,1.326,0,0,1-.915-.277,1.656,1.656,0,0,1-.511-1.289l-2.565,1.029a1.133,1.133,0,0,1-.848-.2.841.841,0,0,1,.158-1.261c.27-.21,4.324-3.33,7.4-3.33.084,0,.167,0,.249.007,2.065.119,5.826,2.786,6.929,3.6a.1.1,0,1,1-.117.159c-1.092-.806-4.813-3.446-6.823-3.562-3.066-.177-7.483,3.253-7.528,3.288a.093.093,0,0,1-.019.011.648.648,0,0,0-.125.938.974.974,0,0,0,.651.165l2.694-1.081a.1.1,0,0,1,.135.093,1.566,1.566,0,0,0,.441,1.281,1.185,1.185,0,0,0,.9.218.1.1,0,0,1,.113.129.606.606,0,0,0,.032.541c.247.409.984.523.992.525a.1.1,0,0,1,.07.047c.665,1.1,1.928.426,1.982.4a.1.1,0,0,1,.118.018l2.021,2.076a.1.1,0,0,1-.071.168",
    transform: "translate(-1529.279 -282.482)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418866",
    "data-name": "Path 418866",
    d: "M1702.98,335.753a.671.671,0,0,1-.267-.055,1.064,1.064,0,0,1-.5-.525,2,2,0,0,1,.02-1.818.1.1,0,0,1,.174.093,1.8,1.8,0,0,0-.018,1.636.875.875,0,0,0,.405.433.416.416,0,0,0,.49-.1.714.714,0,0,0,.092-.359,1.434,1.434,0,0,1,.046-.292,1.354,1.354,0,0,1,.967-.754c.392-.134.755-.28.883-.594a.1.1,0,0,1,.183.075,1.52,1.52,0,0,1-1,.706c-.36.123-.742.294-.842.624a1.269,1.269,0,0,0-.039.253.867.867,0,0,1-.128.457.565.565,0,0,1-.462.218",
    transform: "translate(-1625.59 -318.339)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418867",
    "data-name": "Path 418867",
    d: "M1721.6,355.819a.1.1,0,0,1-.024-.194,4.392,4.392,0,0,0,1.78-.92c.3-.253.428-.492.394-.71a.6.6,0,0,0-.521-.44,1.471,1.471,0,0,0-.773.17.1.1,0,0,1-.083-.179,1.647,1.647,0,0,1,.882-.187.788.788,0,0,1,.69.606,1.014,1.014,0,0,1-.461.891,4.588,4.588,0,0,1-1.86.962.1.1,0,0,1-.024,0",
    transform: "translate(-1644.214 -337.485)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418868",
    "data-name": "Path 418868",
    d: "M1746.04,381.5a.1.1,0,0,1-.027-.194,6.9,6.9,0,0,0,1.627-.706,1.041,1.041,0,0,0,.516-.527.672.672,0,0,0-.31-.705,1.392,1.392,0,0,0-.852-.181.1.1,0,1,1-.01-.2,1.58,1.58,0,0,1,.972.214.873.873,0,0,1,.39.925,1.21,1.21,0,0,1-.6.642,7.11,7.11,0,0,1-1.674.727.1.1,0,0,1-.027,0",
    transform: "translate(-1667.557 -361.968)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418869",
    "data-name": "Path 418869",
    d: "M1794.673,404.141a.1.1,0,0,1-.066-.025.814.814,0,0,0-.883-.113.1.1,0,0,1-.09-.176,1,1,0,0,1,1.1.141.1.1,0,0,1-.065.172",
    transform: "translate(-1713.057 -385.597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418870",
    "data-name": "Path 418870",
    d: "M2177.38,747.451h-10.344a.1.1,0,0,1,0-.2h10.344a.1.1,0,0,1,0,.2",
    transform: "translate(-2069.653 -713.705)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418871",
    "data-name": "Path 418871",
    d: "M2.721,456.214l15.647.14,3.77,4.02,0-7.56,0-7.523c0-.429-.232-.777-.521-.777l-18.879.014c-.289,0-.524.348-.525.777L2.2,455.437c0,.429.232.777.521.777",
    transform: "translate(-2.101 -424.557)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418872",
    "data-name": "Path 418872",
    d: "M20.037,458.37a.1.1,0,0,1-.072-.031l-3.741-3.989-15.6-.14a.507.507,0,0,1-.361-.161A1.021,1.021,0,0,1,0,453.335L.022,443.2c0-.491.275-.875.623-.875l18.879-.014a.508.508,0,0,1,.361.161,1.021,1.021,0,0,1,.259.715l-.008,15.083a.1.1,0,0,1-.062.092.1.1,0,0,1-.036.007m-.513-15.86-18.879.014c-.23,0-.425.311-.426.678L.2,453.335a.822.822,0,0,0,.2.575.319.319,0,0,0,.221.1h0l15.647.14a.1.1,0,0,1,.071.031l3.6,3.838.008-14.834a.823.823,0,0,0-.2-.575.32.32,0,0,0-.221-.1",
    transform: "translate(0 -422.455)",
    fill: "#5479f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418873",
    "data-name": "Path 418873",
    d: "M89.095,490.018a.1.1,0,0,1-.1-.1V488.3a.1.1,0,0,1,.1-.1,2.578,2.578,0,1,0-2.433-3.436.1.1,0,0,1-.186-.066,2.777,2.777,0,1,1,2.718,3.7v1.519a.1.1,0,0,1-.1.1",
    transform: "translate(-82.588 -461.173)",
    fill: "#5479f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418874",
    "data-name": "Path 418874",
    d: "M142.879,655.123a.1.1,0,0,1-.1-.1v-.673a.1.1,0,1,1,.2,0v.673a.1.1,0,0,1-.1.1",
    transform: "translate(-136.37 -624.879)",
    fill: "#5479f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418875",
    "data-name": "Path 418875",
    d: "M244.543,490.018a.1.1,0,0,1-.1-.1V488.3a.1.1,0,0,1,.1-.1,2.578,2.578,0,1,0-2.433-3.436.1.1,0,0,1-.186-.066,2.777,2.777,0,1,1,2.718,3.7v1.519a.1.1,0,0,1-.1.1",
    transform: "translate(-231.057 -461.173)",
    fill: "#5479f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418876",
    "data-name": "Path 418876",
    d: "M298.327,655.123a.1.1,0,0,1-.1-.1v-.673a.1.1,0,1,1,.2,0v.673a.1.1,0,0,1-.1.1",
    transform: "translate(-284.839 -624.879)",
    fill: "#5479f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418877",
    "data-name": "Path 418877",
    d: "M1922.28,995.472h-4.451a.1.1,0,0,1,0-.2h4.352v-20.81h-4.352a.1.1,0,0,1,0-.2h4.451a.1.1,0,0,1,.1.1v21.008a.1.1,0,0,1-.1.1",
    transform: "translate(-1831.634 -930.527)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418878",
    "data-name": "Path 418878",
    d: "M1926.626,1493.04h-8.793a.1.1,0,1,1,0-.2h8.793a.1.1,0,0,1,0,.2",
    transform: "translate(-1831.637 -1425.821)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418879",
    "data-name": "Path 418879",
    d: "M2657.979,828.8h-3.73a.1.1,0,0,1,0-.2h3.73a.1.1,0,0,1,0,.2",
    transform: "translate(-2534.992 -791.406)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418880",
    "data-name": "Path 418880",
    d: "M1960.308,828.8H1930.9a.1.1,0,0,1,0-.2h29.412a.1.1,0,0,1,0,.2",
    transform: "translate(-1844.114 -791.406)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418881",
    "data-name": "Path 418881",
    d: "M2461.692,883.281h-12.957a.1.1,0,0,1,0-.2h12.957a.1.1,0,1,1,0,.2",
    transform: "translate(-2338.705 -843.437)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418882",
    "data-name": "Path 418882",
    d: "M2234.286,883.281h-6.6a.1.1,0,0,1,0-.2h6.6a.1.1,0,0,1,0,.2",
    transform: "translate(-2127.576 -843.437)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418883",
    "data-name": "Path 418883",
    d: "M2515.208,977.626h-10.441a.1.1,0,0,1,0-.2h10.342V937.758h-4.978a.1.1,0,0,1,0-.2h5.077a.1.1,0,0,1,.1.1v39.869a.1.1,0,0,1-.1.1",
    transform: "translate(-2392.221 -895.468)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418884",
    "data-name": "Path 418884",
    d: "M2241.49,937.758h-13.808a.1.1,0,0,1,0-.2h13.808a.1.1,0,1,1,0,.2",
    transform: "translate(-2127.576 -895.468)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418885",
    "data-name": "Path 418885",
    d: "M2649.1,1069.208a1.356,1.356,0,1,0-1.354-1.356,1.355,1.355,0,0,0,1.354,1.356",
    transform: "translate(-2528.876 -1018.615)",
    fill: "#e2eaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418886",
    "data-name": "Path 418886",
    d: "M2649.1,1157.347a1.356,1.356,0,1,0-1.354-1.356,1.355,1.355,0,0,0,1.354,1.356",
    transform: "translate(-2528.876 -1102.797)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418887",
    "data-name": "Path 418887",
    d: "M2647,1155.344a1.455,1.455,0,1,1,1.453-1.455,1.455,1.455,0,0,1-1.453,1.455m0-2.712a1.257,1.257,0,1,0,1.256,1.257,1.258,1.258,0,0,0-1.256-1.257",
    transform: "translate(-2526.776 -1100.696)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418888",
    "data-name": "Path 418888",
    d: "M2649.1,1245.485a1.356,1.356,0,1,0-1.354-1.356,1.355,1.355,0,0,0,1.354,1.356",
    transform: "translate(-2528.877 -1186.978)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418889",
    "data-name": "Path 418889",
    d: "M2647,1243.483a1.455,1.455,0,1,1,1.453-1.455,1.455,1.455,0,0,1-1.453,1.455m0-2.712a1.257,1.257,0,1,0,1.256,1.257,1.258,1.258,0,0,0-1.256-1.257",
    transform: "translate(-2526.776 -1184.878)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418890",
    "data-name": "Path 418890",
    d: "M2108.812,1468.881a1.562,1.562,0,0,0-1.74,1.361,1.608,1.608,0,0,0-.01.19,6.365,6.365,0,0,0-1.832.51,1.562,1.562,0,1,0-2.44,1.91,6.379,6.379,0,0,0-.935,1.655,1.587,1.587,0,0,0-.187-.035,1.562,1.562,0,1,0-.188,3.111,6.372,6.372,0,0,0,.51,1.831,1.587,1.587,0,0,0-.157.107,1.562,1.562,0,1,0,2.067,2.333,6.366,6.366,0,0,0,1.655.935,1.609,1.609,0,0,0-.035.187,1.562,1.562,0,1,0,3.111.188,6.369,6.369,0,0,0,1.831-.509,1.649,1.649,0,0,0,.107.157,1.562,1.562,0,1,0,2.333-2.067,6.377,6.377,0,0,0,.935-1.655,1.593,1.593,0,0,0,.187.035,1.562,1.562,0,0,0,.378-3.1,1.582,1.582,0,0,0-.19-.01,6.378,6.378,0,0,0-.51-1.832,1.532,1.532,0,0,0,.157-.107,1.562,1.562,0,1,0-1.925-2.46,1.649,1.649,0,0,0-.141.127,6.385,6.385,0,0,0-1.656-.935,1.608,1.608,0,0,0,.035-.187,1.562,1.562,0,0,0-1.361-1.74m-.614,5.038a2.9,2.9,0,1,1-3.23,2.528,2.9,2.9,0,0,1,3.23-2.528",
    transform: "translate(-2005.641 -1402.924)",
    fill: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418891",
    "data-name": "Path 418891",
    d: "M2461.607,1393.886a1.061,1.061,0,0,0-1.182.925,1.147,1.147,0,0,0-.007.129,4.323,4.323,0,0,0-1.244.346,1.108,1.108,0,0,0-.073-.107,1.061,1.061,0,1,0-1.67,1.307.98.98,0,0,0,.086.1,4.33,4.33,0,0,0-.635,1.124,1.019,1.019,0,0,0-.127-.024,1.061,1.061,0,1,0-.257,2.106,1.041,1.041,0,0,0,.129.007,4.327,4.327,0,0,0,.346,1.244,1.036,1.036,0,0,0-.107.073,1.061,1.061,0,1,0,1.308,1.67,1.09,1.09,0,0,0,.1-.086,4.332,4.332,0,0,0,1.125.635,1.081,1.081,0,0,0-.024.127,1.061,1.061,0,0,0,2.106.257,1.094,1.094,0,0,0,.007-.129,4.326,4.326,0,0,0,1.244-.346,1.111,1.111,0,0,0,.073.107,1.061,1.061,0,0,0,1.671-1.308,1.048,1.048,0,0,0-.086-.1,4.331,4.331,0,0,0,.635-1.124,1.1,1.1,0,0,0,.127.024,1.061,1.061,0,1,0,.128-2.113,4.329,4.329,0,0,0-.346-1.244,1.06,1.06,0,1,0-1.2-1.743,1.043,1.043,0,0,0-.1.086,4.327,4.327,0,0,0-1.124-.635,1.021,1.021,0,0,0,.024-.127,1.06,1.06,0,0,0-.924-1.181m-.417,3.421a1.97,1.97,0,1,1-2.194,1.717,1.97,1.97,0,0,1,2.194-1.717",
    transform: "translate(-2345.323 -1331.299)",
    fill: "#e3e3e3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardEmployeeQueries);
export default __webpack_public_path__ + "static/media/dashboard-employee-queries.f49430577324bfe0fb494fd26b7287ff.svg";
export { ForwardRef as ReactComponent };